import editSetting from './editSetting';

export default {
  list: editSetting,
};
